import { request } from '@/api/request'

export const configSite = data =>
  request('/portal/verify/waf/resource/site/config', { method: 'post', data })

//校验站点名称是否存在
export const checkSiteName = data =>
  request('/portal/verify/waf/resource/site/checkSiteName', {
    method: 'post',
    data,
  })

export const deviceProducer = () => request('/portal/verify/waf/resource/site/deviceProducer')

export const importSuccessFile = data =>
  request('/portal/verify/waf/resource/site/wafSiteExecImport', { method: 'post', data })
